import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import Typography from "@mui/material/Typography";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import EditIcon from "@mui/icons-material/Edit";
import PostAddIcon from "@mui/icons-material/PostAdd";
import Button from "../../components/Button";
import { StyledSwitch } from "../../components/Base";
import TableComponent from "../../components/TableComponent";
import { getProcessStep, deleteProcessStepById, updateProcessStep } from "../../api/process-step";
import Confirm from "../../components/Confirm";

const ProcessStepTable = ({ match, history }) => {
  const { t } = useTranslation();
  const [processStep, setProcessStep] = useState(null);

  const [selectedOperationId, setSelectedOperationId] = useState(null);
  const [isDeleteModalShow, setIsDeleteModalShow] = useState(false);
  const [refresh, setRefresh] = useState(1);

  function showDeleteModal(id) {
    setSelectedOperationId(id);
    setIsDeleteModalShow(true);
  }

  async function confirmDeleteModal(isConfirmed) {
    if (isConfirmed) {
      await deleteProcessStepById(selectedOperationId);
    }
    setIsDeleteModalShow(false);
    setRefresh(refresh * -1);
  }

  useEffect(() => {
    (async () => {
      const res = await getProcessStep();
      setProcessStep(res);
    })();
  }, [refresh]);

  return (
    <>
      <Typography variant="h4">{t("process_step.title")}</Typography>
      {processStep ? (
        <TableComponent
          TopComponent={
            <Button size="small" onClick={() => history.push(`/process-step/add`)}>
              <PostAddIcon />
              {t("process_step.add_action")}
            </Button>
          }
          search={["name"]}
          header={[
            { title: t("id"), style: { width: "5%" } },
            { title: t("name") },
            { title: t("training.type") },
            { title: t("status") },
            { title: t("process_step.activity_trainings") },
            { title: t("actions") },
          ]}
          items={processStep}
          renderChildren={(ps) => (
            <TableRow key={ps.id}>
              <TableCell>{ps.id}</TableCell>
              <TableCell>{ps.name}</TableCell>
              <TableCell>{ps.type}</TableCell>
              <TableCell>{ps.status === "active" ? t("active") : t("not_active")}</TableCell>
              <TableCell>
                {ps.activitiesTrainings.map((at) => (
                  <li key={`${ps.id}-${at.id}`}>
                    {at.id} - {at.name}
                  </li>
                ))}
              </TableCell>
              <TableCell>
                <Button
                  icon={<EditIcon />}
                  onClick={() => history.push(`/process-step/edit/${ps.id}`)}
                  title={t("process_step.edit_action")}
                />
                <Button
                  icon={<DeleteForeverIcon />}
                  onClick={() => showDeleteModal(ps.id)}
                  title={t("process_step.delete_action")}
                />
              </TableCell>
            </TableRow>
          )}
        />
      ) : null}

      {isDeleteModalShow && selectedOperationId ? (
        <Confirm title={t("process_step.delete_action")} onConfirm={confirmDeleteModal}>
          <p>{t("process_step.delete_confirm")}</p>
        </Confirm>
      ) : null}
    </>
  );
};

export default ProcessStepTable;
